// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1B0UY","name":"styles_name__2Ttpj","phone":"styles_phone__1Ycot"};